module.exports = __webpack_public_path__ + "static/img/left-num-row-5.5f831e08.webp";